export const CRED_LABELS = {
  STATE_LICENSE: "State Medical License",
  DEA: "DEA Registration",
  LA_CDS: "Louisiana CDS Certificate",
  BOARD_CERT: "Board Certification",
  BLS: "BLS",
  ACLS: "ACLS",
  PALS: "PALS",
  MALPRACTICE: "Malpractice Insurance",
  NPDB_QUERY: "NPDB Query",
  OIG_EXCLUSION: "OIG LEIE Check",
  SAM_EXCLUSION: "SAM Exclusion",
  LDH_ADVERSE: "LDH Adverse Actions",
  TB_TEST: "TB / PPD Test",
  HEPB_IMMUNIZATION: "Hepatitis B Immunization",
  INFLUENZA: "Influenza Vaccination",
  FIT_TEST: "N95 Fit Test",
  PRIVILEGES: "Clinical Privileges",
  RECREDENTIAL_CYCLE: "Re-credentialing Cycle",
  PEER_REFERENCES: "Peer References",
  ECFMG: "ECFMG Certification",
  HEALTH_STATUS: "Health Status Attestation",
  CRIMINAL_BG: "Criminal Background",
  NPI: "NPI",
};

export const CRED_TYPES = Object.keys(CRED_LABELS);

export const TITLES = ["MD", "DO", "CRNA", "RN", "LPN", "NP", "PA", "ST"];

export const TITLE_LABELS = {
  MD: "Medical Doctor",
  DO: "Doctor of Osteopathy",
  CRNA: "Certified Reg. Nurse Anesthetist",
  RN: "Registered Nurse",
  LPN: "Licensed Practical Nurse",
  NP: "Nurse Practitioner",
  PA: "Physician Assistant",
  ST: "Surgical Technologist",
};

export const PSV_STATUS = ["PENDING", "VERIFIED", "FAILED", "NA"];

export const STATUS_META = {
  EXPIRED: { label: "Expired", cls: "status-expired" },
  EXPIRING_7: { label: "≤ 7 days", cls: "status-exp-7" },
  EXPIRING_30: { label: "≤ 30 days", cls: "status-exp-30" },
  EXPIRING_60: { label: "≤ 60 days", cls: "status-exp-60" },
  EXPIRING_90: { label: "≤ 90 days", cls: "status-exp-90" },
  CURRENT: { label: "Current", cls: "status-current" },
  NO_DATE: { label: "No date", cls: "status-no-date" },
  MISSING: { label: "Missing", cls: "status-missing" },
};

export function daysUntil(dateStr) {
  if (!dateStr) return null;
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return null;
  const today = new Date();
  today.setHours(0,0,0,0);
  d.setHours(0,0,0,0);
  return Math.round((d - today) / (1000*60*60*24));
}

export function formatDate(dateStr) {
  if (!dateStr) return "—";
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return "—";
  return d.toLocaleDateString("en-US", { year: "numeric", month: "short", day: "2-digit" });
}
